import { Transaction } from '../types'

export type TransactionsResponse = {
  data: { transactions: Transaction[] }
}

export type Args = {
  skip?: number
  first?: number
  sortDir: 'asc' | 'desc'
  walletAddress: string
}

export const getQueryGraphTransactions = (arg: Args) => `{
  transactions(
    ${arg.skip !== undefined ? `skip: ${arg.skip}` : ''}
    ${arg.first !== undefined ? `first: ${arg.first}` : ''}
    where: { from: "${arg.walletAddress}"}
    orderBy: timestamp
    orderDirection: ${arg.sortDir}
  ) {
    id
    from
    to
    value
    transactionType
    gasPrice
    timestamp
    transactionBlock
  }
}`
